/* eslint-disable */
import React from 'react';
import styles from './breakdown.module.scss';
import PropTypes from 'prop-types';

const Breakdown = ({ data }) => {
  if (!data?.days || !data?.percent) {
    return null;
  }

  const effortData = [
    {
      color: '#08B758',
      label: 'FE',
      days: `${data.days.feEfforts || 0} days`,
      value: data.days.feEfforts,
    },
    {
      color: '#7BC9FF',
      label: 'BE',
      days: `${data.days.beEfforts || 0} days`,
      value: data.days.beEfforts,
    },
    {
      color: '#848AF5',
      label: 'Testing',
      days: `${data.days.testingEfforts || 0} days`,
      value: data.days.testingEfforts,
    },
    {
      color: '#FFD465',
      label: 'PM',
      days: `${data.days.pmEfforts || 0} days`,
      value: data.days.pmEfforts,
    },
    {
      color: '#FFB7BF',
      label: 'Other',
      days: `${data.days.otherEfforts || 0} days`,
      value: data.days.otherEfforts,
    },
  ].filter((item) => item.value > 0);

  const effortBars = [
    {
      color: '#08B758',
      percentage: `${data.percent.feEfforts || 0}%`,
      value: data.percent.feEfforts,
    },
    {
      color: '#7BC9FF',
      percentage: `${data.percent.beEfforts || 0}%`,
      value: data.percent.beEfforts,
    },
    {
      color: '#848AF5',
      percentage: `${data.percent.testingEfforts || 0}%`,
      value: data.percent.testingEfforts,
    },
    {
      color: '#FFD465',
      percentage: `${data.percent.pmEfforts || 0}%`,
      value: data.percent.pmEfforts,
    },
    {
      color: '#FFB7BF',
      percentage: `${data.percent.otherEfforts || 0}%`,
      value: data.percent.otherEfforts,
    },
  ].filter((item) => item.value > 0);

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div className={styles.title}>Efforts Breakdown</div>
        <div className={styles['breakdown-container']}>
          {effortData.map((item) => (
            <div className={styles['breakdown-item']} key={item.label}>
              <div
                className={styles.indicator}
                style={{ background: item.color }}
              />
              <div className={styles.label}>{item.label}</div>
              <div className={styles.days}>{item.days}</div>
            </div>
          ))}
        </div>
      </div>

      <div className={styles['effort-bar-container']}>
        {effortBars.map((bar) => (
          <div
            className={styles['effort-bar']}
            key={bar.color}
            style={{ background: bar.color, width: bar.percentage }}
          >
            <div className={styles['effort-label']}>{bar.percentage}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

Breakdown.propTypes = {
  data: PropTypes.shape({
    days: PropTypes.shape({
      feEfforts: PropTypes.number,
      beEfforts: PropTypes.number,
      testingEfforts: PropTypes.number,
      pmEfforts: PropTypes.number,
      otherEfforts: PropTypes.number,
    }),
    percent: PropTypes.shape({
      feEfforts: PropTypes.number,
      beEfforts: PropTypes.number,
      testingEfforts: PropTypes.number,
      pmEfforts: PropTypes.number,
      otherEfforts: PropTypes.number,
    }),
  }),
};

export default Breakdown;